export default __webpack_public_path__ + "static/media/google.1f1f92ea.svg";